import React, { useCallback } from 'react';
import { Checkbox } from 'primereact/checkbox';

// Arbol de checkboxes tri-state sobre una definicion de menu (getMenuAdminDefinition).
// `ocultos` es un Set de menuKey (el `to` de cada hoja, sin la barra inicial).
// Se usa tanto en PermisosMenuPerfilAdministrador (permisos del Administrador sobre
// el Perfil Administrador) como en Administradoras (permisos del Superadmin sobre
// toda la administradora) - misma UI, distinto backend detras de onToggleItem/onToggleGrupo.
export const keyDeMenuItem = (item) => (item.to ? item.to.replace(/^\//, '') : null);

export const hojasDeMenuItem = (item, restringidos) => {
    const key = keyDeMenuItem(item);
    if (key) return restringidos.includes(key) ? [] : [key];
    if (item.items) return item.items.flatMap((sub) => hojasDeMenuItem(sub, restringidos));
    return [];
};

const ArbolMenuCheckboxes = ({ definicionMenu, ocultos, onToggleItem, onToggleGrupo, restringidos = [] }) => {
    const hojasDe = useCallback((item) => hojasDeMenuItem(item, restringidos), [restringidos]);

    const renderNodo = (item, nivel) => {
        const key = keyDeMenuItem(item);

        if (key) {
            if (restringidos.includes(key)) return null;
            const checked = !ocultos.has(key);
            return (
                <div key={key} className="flex align-items-center gap-2 py-1" style={{ marginLeft: nivel * 24 }}>
                    <Checkbox inputId={`menu-${key}`} checked={checked} onChange={() => onToggleItem(key)} />
                    <label htmlFor={`menu-${key}`} style={{ cursor: 'pointer' }}>{item.label}</label>
                </div>
            );
        }

        if (item.items) {
            const claves = hojasDe(item);
            const tildadas = claves.filter((k) => !ocultos.has(k));
            const todasTildadas = claves.length > 0 && tildadas.length === claves.length;
            const algunaTildada = tildadas.length > 0 && !todasTildadas;

            return (
                <div key={item.label} style={{ marginLeft: nivel * 24 }} className="mb-2">
                    <div className="flex align-items-center gap-2 py-1">
                        {claves.length > 0 && (
                            <Checkbox
                                checked={todasTildadas}
                                className={algunaTildada ? 'p-checkbox-indeterminate' : ''}
                                onChange={(e) => onToggleGrupo(item, e.checked)}
                            />
                        )}
                        <strong>{item.label}</strong>
                    </div>
                    {item.items.map((sub) => renderNodo(sub, nivel + 1))}
                </div>
            );
        }

        return null;
    };

    return <div>{definicionMenu.map((item) => renderNodo(item, 0))}</div>;
};

export default ArbolMenuCheckboxes;
